import React from 'react'

const MenuButton = ({open}) => {
    return (
        <div className="">
            <button className="lg:hidden bg-blue-500 mt-2 pl-2 pr-2 pt-1 pb-1 rounded text-white">Menu bar</button>
        </div>
    )
}    

export default MenuButton
